import i18next from 'i18next'
const getPOSBaseExportColumns = (): Record<string, string> => ({
    transactionDate: i18next.t('pos-transaction.transactionDate'),
    amount: i18next.t('pos-transaction.amount'),
    currency: i18next.t('pos-transaction.currency'),
    status: i18next.t('pos-transaction.status'),
    returnCode: i18next.t('pos-transaction.returnCode'),
    returnCodeDescription: i18next.t('pos-transaction.returnCodeDescription'),
    transactionId: i18next.t('pos-transaction.transaction.id'),
    mid: i18next.t('pos-transaction.mid'),
    terminalId: i18next.t('pos-transaction.terminalId'),
    transactionType: i18next.t('pos-transaction.transaction.type'),
    transactionDetails: i18next.t('pos-transaction.transaction.details'),
    transactionCountry: i18next.t('pos-transaction.transaction.country'),
    transactionCity: i18next.t('pos-transaction.transaction.city'),
    cardScheme: i18next.t('pos-transaction.cardScheme'),
    cardMask: i18next.t('pos-transaction.cardMask')
})

export const getPOSExportColumns = () => {
    const base = {
        ...getPOSBaseExportColumns(),
        cardType: i18next.t('pos-transaction.cardType'),
        issuerRegion: i18next.t('pos-transaction.issuerRegion'),
        isCorporateCard: i18next.t('pos-transaction.isCorporateCard'),
        captureMethod: i18next.t('pos-transaction.captureMethod'),
        dccCardholderAmount: i18next.t('pos-transaction.dccCardholderAmount'),
        dccCardholderCurrency: i18next.t('pos-transaction.dccCardholderCurrency'),
        dccExchangeRate: i18next.t('pos-transaction.dccExchangeRate'),
        dccRebateRate: i18next.t('pos-transaction.dccRebateRate'),
        dccRebateAmount: i18next.t('pos-transaction.dccRebateAmount'),
        dccRebateCurrency: i18next.t('pos-transaction.dccRebateCurrency')
    }

    return base
}

export const getPOSAmexExportColumns = () => ({
    ...getPOSBaseExportColumns(),
    captureMethod: i18next.t('pos-transaction.captureMethod')
})
